import React from 'react';

const IconSearch = ({ size = '20' }) => (
  <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M20.72 19.34l-5.52-5.59a6.82 6.82 0 0 0 1.24-3.93c0-3.76-3.01-6.81-6.72-6.81S3 6.05 3 9.81s3.01 6.81 6.72 6.81c1.57 0 3.01-.55 4.16-1.47l5.49 5.56c.19.19.43.29.68.29s.49-.1.68-.29c.38-.38.38-1 0-1.38zM4.92 9.81c0-2.68 2.15-4.86 4.8-4.86s4.8 2.18 4.8 4.86-2.15 4.86-4.8 4.86-4.8-2.18-4.8-4.86"
      fill="#fff"
    />
  </svg>
);

export default IconSearch;
